
type Primitive = number | bigint | boolean | string | null | undefined;

export default function areArraysEqual<T extends Primitive>(array1: T[], array2: T[]): boolean {
    if (!Array.isArray(array1) || !Array.isArray(array2)) return false;

    const a = [...array1].sort();
    const b = [...array2].sort();

    return (
        a.length === b.length
        && a.every((value, index) => value === b[index])
    );
}